/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 実行対象タイプ
 */
export type JobsExecutionTargetType =
  (typeof JobsExecutionTargetType)[keyof typeof JobsExecutionTargetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobsExecutionTargetType = {
  assessments: 'assessments',
  euc: 'euc',
  settlement_statistics_converter: 'settlement_statistics_converter',
  project_bulk_create: 'project_bulk_create',
  project_reference_chats: 'project_reference_chats',
  project_bulk_reference_chats: 'project_bulk_reference_chats',
} as const;
